import { useMemo } from 'react';
import tw from 'twin.macro';

import { useEpisodeDetailsContext } from '@insights_module/context/EpisodeDetailsContext';
import { ContextualCategory } from '@insights_module/types/Traceability';

const StyledCategoryLabel = tw.div`bg-sec-4 py-[4px] px-[12px] rounded-[4px] text-text-and-icon tracking-[0.14px] text-[14px] whitespace-nowrap font-medium`;

export const ContextualCategoryLabel = ({ category }: { category: ContextualCategory }) => {
  const { selectedContextualCategory } = useEpisodeDetailsContext();
  const isSelected = useMemo(
    () => selectedContextualCategory === category.name,
    [selectedContextualCategory]
  );

  return (
    <StyledCategoryLabel
      css={[
        isSelected && tw`bg-sec-3!`,
        selectedContextualCategory &&
          category.name !== selectedContextualCategory &&
          tw`opacity-50`,
      ]}>
      {category.display_name}
    </StyledCategoryLabel>
  );
};
